export enum TransactionType {
    IncreaseBalance = 1,
    DecreaseBalance = 2,
}
